import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import TextInput from "../../../components/forms/TextInput";
import { IFilterInscription, getDefaultFilterInscription } from "../../../models/interfaces/IFilterInscription";
import { statutsListInscription, validationMode } from "../../../config/helpers";
import CpntMultiSelect from "../../../components/CpntMultiSelect";
import CpntFilterButtons from "../../../components/CpntFilterButtons";

interface IProps {
  filter?: IFilterInscription;
  changeFilter: (data: IFilterInscription) => void;
}

const InscriptionsFilter: React.FC<IProps> = ({ filter, changeFilter }) => {
  const prevFilterRef = useRef<IFilterInscription | undefined>(filter);
  const [selectedStatuts, setSelectedStatuts] = useState<any[]>([]);
  
 
  useEffect(() => {
    if (JSON.stringify(prevFilterRef.current) !== JSON.stringify(filter) || getValues() !== JSON.stringify(filter)) {
      reset(filter);
    }
    prevFilterRef.current = filter;
  }, [filter]);

  const formMethods = useForm<IFilterInscription>({
    defaultValues: getDefaultFilterInscription(),
  });

  const { handleSubmit, reset, getValues } = formMethods;

  const handleResetForm = () => {
    localStorage.removeItem("IFilterInscriptions");
    setSelectedStatuts([]);
    changeFilter(getDefaultFilterInscription());
    reset(getDefaultFilterInscription());
  };

  const handleSubmitForm = () => {
    handleSubmit(onSubmit)();
  };

  const onSubmit = (data: IFilterInscription) => {
    const idsEtatDemandeInscription = selectedStatuts.map((option: { value: any }) => option.value);
    const combinedData: IFilterInscription = {
      ...data,
      IdsEtatDemandeInscription: idsEtatDemandeInscription,
    };
    changeFilter(combinedData);
    localStorage.setItem("IFilterInscriptions", JSON.stringify(combinedData));
  };

  const handleKeyPress = (e: { key: string; preventDefault: () => void }) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };
 const mappedOptionsStatuts = statutsListInscription?.map((statut) => {
    return {
      Id: statut.Id,
      Libelle: statut.Libelle,
    };
  }) || [];
  useEffect(() => {
    if (filter?.IdsEtatDemandeInscription) {
      const selectedStatutsValues = statutsListInscription?.filter((statut) =>
        filter?.IdsEtatDemandeInscription?.includes(statut.Id)
      ) || [];
      const selectedStatutsList = selectedStatutsValues?.map((statut) => {
        return {
          label: statut.Libelle,
          value: statut.Id,
        };
      });
      setSelectedStatuts(selectedStatutsList);
    }
  }, [filter?.IdsEtatDemandeInscription]);

  return (
    <FormProvider {...formMethods}>
      <form onKeyPress={handleKeyPress}>
        <CpntFormSection pSectionLabel="FILTRES">
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6]}>
            <TextInput
              label="Email"
              formName="Email"
              validationStyle={validationMode.classic}
              placeholder="Rechercher par email"
            />
            <TextInput
              label="Raison sociale"
              formName="RaisonSociale"
              validationStyle={validationMode.classic}
              placeholder="Rechercher par raison sociale"
            />
          </CpntFormSectionContainer>
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6]}>
            <TextInput
                          label="Nom prénom"
                          formName="NomPrenom"
                          validationStyle={validationMode.none}
                          placeholder="Nom prénom"
            />
          </CpntFormSectionContainer>
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
            <CpntMultiSelect
                    label="Statut"
                    options={mappedOptionsStatuts}
                    value={selectedStatuts}
                    setSelected={setSelectedStatuts}
                    DefaultLibelle="Sélectionner un ou plusieurs statuts"
                />
          </CpntFormSectionContainer>
        </CpntFormSection>
        <CpntFilterButtons
          submitForm={handleSubmitForm}
          resetForm={handleResetForm}
        />
      </form>
    </FormProvider>
  );
};

export default InscriptionsFilter;
